import {Injectable} from "@angular/core";
import {BehaviorSubject, map, Observable, tap} from "rxjs";
import {Email} from "../model/email.model";
import {HttpClient} from "@angular/common/http";
import {EmailDto} from "admin-api-dto";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  get emails$(): Observable<Email[]> {
    return this._emails$.asObservable();
  }

  private readonly _emails$ = new BehaviorSubject<Email[]>([]);

  constructor(private readonly http: HttpClient) {
    this.retrieveEmails().subscribe();
  }

  private retrieveEmails(): Observable<unknown> {
    return this.http.get<EmailDto[]>(`${environment.apiUrl}/api/private/emails`).pipe(
      map(emails => emails.sort((a, b) => b.timestamp.localeCompare(a.timestamp))),
      tap(emails => this._emails$.next(emails)));
  }

  getEmail(s3Key: string): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${environment.apiUrl}/api/private/emails/download`, {
      params: {s3Key: s3Key}
    });
  }

  openEmail(s3Key: string) {
    this.getEmail(s3Key).subscribe({
      next: ({url}) => {
        window.open(url, '_blank');
      },
      error: (error) => {
        console.error('Error opening email:', error);
      }
    });
  }

  retryEmail(s3Key: string): Observable<Email> {
    return this.http.put<EmailDto>(`${environment.apiUrl}/api/private/emails/retry`, {s3Key}).pipe();
  }
}
